export class UserProfileDto {
  profileUuid: string;
  imageUrl: string;
  username: string;
  birthdate: string;
  about: string;
  email: string;

  constructor(profileUuid: string, imageUrl: string, username: string, birthdate: string,
              about: string, email: string) {
    this.profileUuid = profileUuid;
    this.imageUrl = imageUrl;
    this.username = username;
    this.birthdate = birthdate;
    this.about = about;
    this.email = email;
  }
}
